/**
 * @generated SignedSource<<2f8be9a4b00ccc935f3f02f2960a1edf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ShowAnswerTreeConfigType = "ShowAnswerTree_AfterDateTimeDo" | "ShowAnswerTree_DoNot" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type AfterDateTimeDoShowAnswerTreeConfigForm_AfterDateTimeDoShowAnswerTreeConfigFragment$data = {
  readonly configType: ShowAnswerTreeConfigType;
  readonly dateTime: string;
  readonly id: string;
  readonly " $fragmentType": "AfterDateTimeDoShowAnswerTreeConfigForm_AfterDateTimeDoShowAnswerTreeConfigFragment";
};
export type AfterDateTimeDoShowAnswerTreeConfigForm_AfterDateTimeDoShowAnswerTreeConfigFragment$key = {
  readonly " $data"?: AfterDateTimeDoShowAnswerTreeConfigForm_AfterDateTimeDoShowAnswerTreeConfigFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AfterDateTimeDoShowAnswerTreeConfigForm_AfterDateTimeDoShowAnswerTreeConfigFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AfterDateTimeDoShowAnswerTreeConfigForm_AfterDateTimeDoShowAnswerTreeConfigFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "configType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dateTime",
      "storageKey": null
    }
  ],
  "type": "AfterDateTimeDoShowAnswerTreeConfig",
  "abstractKey": null
};

(node as any).hash = "9b1d12cfed1c84d10f44738f62ec0973";

export default node;
